import React from 'react';
import notificationStore from '~/store/notificationStore';
import {ArrowRightUpIcon} from '../icons/ArrowRightUp';
import IconButton from './atoms/buttons/IconButton';
import LinkResolver from './atoms/buttons/LinkResolver';
import UmbracoImageLoader from './UmbracoImage';

const NotificationCard: React.FC = () => {
  const {setDismissed, notification} = notificationStore();

  const handleNotification = async (
    notificationID: string | null | undefined,
  ) => {
    try {
      if (notificationID) {
        const response = await fetch(`/api/notification`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            notificationID,
            isDismissed: 'yes',
          }),
        });

        if (response.ok) {
          setDismissed(true);
        }
      }
    } catch (error: any) {
      return {
        error: error.toString(),
      };
    }
  };
  return (
    <div className="flex w-full flex-col items-start gap-6 rounded-lg  border border-spring/8 bg-white p-6">
      <div className="flex w-full items-center justify-between gap-6">
        <h3 className="text-24 leading-[0.9] tracking-[-0.96px]">
          {notification.title}
        </h3>
        <IconButton
          onClick={() => handleNotification(notification.title)}
          size="small"
          iconName={'Close'}
        ></IconButton>
      </div>
      {notification.image && <UmbracoImageLoader image={notification.image} />}
      <p className="text-sm leading-[1.6] tracking-[-0.28px]">
        {notification.text}
      </p>
      {notification.link && (
        <LinkResolver
          theme="light"
          variant="fill"
          linkData={notification.link}
          onClick={() => handleNotification(notification.title)}
        >
          <span>{notification.link.name}</span>
          <ArrowRightUpIcon className="h-6 w-6" />
        </LinkResolver>
      )}
    </div>
  );
};

export default NotificationCard;
